export default __webpack_public_path__ + "static/media/logout-clock.12151d36.svg";